import React, { useEffect } from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/layout/Layout";
import GetInvolvedPage from "@/pages/GetInvolvedPage";

function App() {
  // Initialize scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.fade-up');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <Layout>
          <GetInvolvedPage />
        </Layout>
      </div>
    </HelmetProvider>
  );
}

export default App;
